import VueI18n from '@/language/index';
import type { MessageSchema } from './index';
const modules = import.meta.glob<{ default: MessageSchema }>('../language/*.ts'); // 导入
// 拥有的翻译import default from './../../../../msitelive/src/mock/index';

const allLanguage = ['en', 'ar', 'in', 'tr', 'pt', 'es', 'vi', 'th'];
// 加载过的翻译，默认加载了英文
const loadLanguage = ['en'];

export function setLanguage(language: any) {
  // 翻译已加载过或者没有对应的翻译文件就return,不往下执行
  if (loadLanguage.includes(language) || !allLanguage.includes(language)) {
    return Promise.resolve();
  }

  return modules[`./${language}.ts`]().then((messages: any) => {
    VueI18n.global.setLocaleMessage(language, messages.default);
    VueI18n.global.locale = language;
    loadLanguage.push(language);
  });
}
